export var PROMOTIONS_PATH;
(function (PROMOTIONS_PATH) {
    PROMOTIONS_PATH["PROMOTIONS_LIST"] = "/promotions/promotionslist";
    PROMOTIONS_PATH["ADD_CAMPAIGN"] = "/promotions/addcampaign";
    PROMOTIONS_PATH["CAMPAIGN_DETAIL"] = "/promotions/campaigndetail";
    // anchor - for code generator
})(PROMOTIONS_PATH || (PROMOTIONS_PATH = {}));
